import React, { useState, useEffect } from 'react';
import Title from './title';
import CollabLogo from './collab-logo';
import { HashLink } from 'react-router-hash-link';


const SideMenu = ({ active, mobileOnly }) => {

    const [openSubmenu, setOpenSubmenu] = useState(null);
    const [currentSection, setCurrentSection] = useState(null);

    // Detect current path
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';

    // Use effect to initialize open submenu based on current URL
    useEffect(() => {
        if (currentPath.startsWith('/before')) {
        setOpenSubmenu('before');
        } else if (currentPath.startsWith('/building')) {
        setOpenSubmenu('building');
        } else if (currentPath.startsWith('/explore')) {
        setOpenSubmenu('explore');
        } 
        else if (currentPath.startsWith('/raid')) {
        setOpenSubmenu('raid');
        } 
        else if (currentPath.startsWith('/after')) {
        setOpenSubmenu('after');
        } 
        else if (currentPath.startsWith('/credits')) {
        setOpenSubmenu('credits');
        } 
    }, [currentPath]);

    const toggleSubmenu = (menuName) => {
        setOpenSubmenu(openSubmenu === menuName ? null : menuName);
    };

    useEffect(() => {
    const handleScroll = () => {
        const headers = document.querySelectorAll('h2[id]');
        let closestHeadingId = null;
        let minDistance = Infinity;
        
        headers.forEach((heading) => {
        const rect = heading.getBoundingClientRect();
        const distance = Math.abs(rect.top);
        
        // Only consider headers within a certain threshold from the top
        if (distance < minDistance && distance < 300) { // threshold of 100px
            minDistance = distance;
            closestHeadingId = heading.id;
        }
        });
        
        if (closestHeadingId) {
        setCurrentSection(closestHeadingId);
        }
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div
        id="sidemenu"
        className={`sidemenu${isOpen ? ' open' : ''}${mobileOnly ? ' mobile-only' : ''}`}
        >
            <div class='sidemenu-wrap'>
                <a href='/#skip' className='skip-fade'>
                    <div style={{height: 'auto', width: '250px'}}>
                        <CollabLogo />
                    </div>
                    <Title />
                </a>
                <button onClick={handleToggle}>
                    {isOpen ? 'Close' : 'Menu'}
                </button>
                <div className='sidemenu-links-wrapper'>
                    <a href='/#skip' className='skip-fade'>HOME</a>
                    <div className='menu-item'>
                        <a
                        href='/before'
                        className={active === 'before' ? 'active' : ''}
                        >
                        BEFORE THE PALACE
                        </a>
                        {/* Button to toggle submenu */}
                        <button
                        onClick={(e) => {
                            e.preventDefault(); // Prevent default to avoid link jump
                            toggleSubmenu('before');
                        }}
                        aria-label='Toggle submenu'
                        >
                        {openSubmenu === 'before' ? '▲' : '▼'}
                        </button>
                        {/* Submenu items */}
                        {openSubmenu === 'before' && (
                        <div className='submenu'>
                            <HashLink to='/before#before-2' className={currentSection === 'before-2' ? 'active' : ''}>The Brunswick Four</HashLink>
                            <HashLink to='/before#before-3' className={currentSection === 'before-3' ? 'active' : ''}>Operation Soap</HashLink>
                            <HashLink to='/before#before-4' className={currentSection === 'before-4' ? 'active' : ''}>Queerness, Sex Work, Police</HashLink>
                        </div>
                        )}
                    </div>
                    <div className='menu-item'>
                        <a href='/building' className={active === 'building' ? 'active' : ''}>BUILDING&nbsp;THE&nbsp;PALACE</a>
                        {/* Button to toggle submenu */}
                        <button
                        onClick={(e) => {
                            e.preventDefault(); // Prevent default to avoid link jump
                            toggleSubmenu('building');
                        }}
                        aria-label='Toggle submenu'
                        >
                        {openSubmenu === 'building' ? '▲' : '▼'}
                        </button>
                        {/* Submenu items */}
                        {openSubmenu === 'building' && (
                        <div className='submenu'>
                            <HashLink to='/building#building-2' className={currentSection === 'building-2' ? 'active' : ''}>Founding the TWBC</HashLink>
                            <HashLink to='/building#building-3' className={currentSection === 'building-3' ? 'active' : ''}>Trans Inclusion</HashLink>
                            <HashLink to='/building#building-4' className={currentSection === 'building-4' ? 'active' : ''}>BIPOC Inclusion</HashLink>
                        </div>
                        )}
                    </div>
                    
                    <a href='/explore/entrance' className={active === 'explore' ? 'active' : ''}>EXPLORE THE PALACE</a>
                    
                    <div className='menu-item'>
                        <a href='/raid' className={active === 'raid' ? 'active' : ''}>RAID&nbsp;ON&nbsp;THE&nbsp;PALACE</a>
                        {/* Button to toggle submenu */}
                        <button
                        onClick={(e) => {
                            e.preventDefault(); // Prevent default to avoid link jump
                            toggleSubmenu('raid');
                        }}
                        aria-label='Toggle submenu'
                        >
                        {openSubmenu === 'raid' ? '▲' : '▼'}
                        </button>
                        {/* Submenu items */}
                        {openSubmenu === 'raid' && (
                        <div className='submenu'>
                            <HashLink to='/raid#raid-2' className={currentSection === 'raid-2' ? 'active' : ''}>The Raid</HashLink>
                            <HashLink to='/raid#raid-3' className={currentSection === 'raid-3' ? 'active' : ''}>Care at the Palace</HashLink>
                            <HashLink to='/raid#raid-4' className={currentSection === 'raid-4' ? 'active' : ''}>Post-Raid Activisim & Civil Suit</HashLink>
                            <HashLink to='/raid#raid-5' className={currentSection === 'raid-5' ? 'active' : ''}>HR Complaint & Class Action</HashLink>
                        </div>
                        )}
                    </div>

                    <a href='/after' className={active === 'after' ? 'active' : ''}>AFTER THE PALACE</a>
                    <div className='menu-item'>
                        <a href='/credits' className={active === 'credits' ? 'active' : ''}>ABOUT</a>
                        {/* Button to toggle submenu */}
                        <button
                        onClick={(e) => {
                            e.preventDefault(); // Prevent default to avoid link jump
                            toggleSubmenu('credits');
                        }}
                        aria-label='Toggle submenu'
                        >
                        {openSubmenu === 'credits' ? '▲' : '▼'}
                        </button>
                        {/* Submenu items */}
                        {openSubmenu === 'credits' && (
                        <div className='submenu'>
                            <HashLink to='/credits#credits-1' className={currentSection === 'credits-1' ? 'active' : ''}>Project</HashLink>
                            <HashLink to='/credits#credits-2' className={currentSection === 'credits-2' ? 'active' : ''}>Team</HashLink>
                            <HashLink to='/credits#credits-3' className={currentSection === 'credits-3' ? 'active' : ''}>Narrators</HashLink>
                            <HashLink to='/credits#credits-4' className={currentSection === 'credits-4' ? 'active' : ''}>Special Thanks</HashLink>
                            <HashLink to='/credits#credits-5' className={currentSection === 'credits-5' ? 'active' : ''}>Resources</HashLink>
                        </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SideMenu;